import * as React from 'react'
import { SVGProps, memo } from 'react'

const CurvedArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={21}
    height={28}
    viewBox='0 0 21 28'
    fill='none'
    {...props}
  >
    <path
      fill='currentColor'
      d='m11.106 27.5 9.896-5.95L10.9 15.954l.206 11.545ZM1.226 3.434c5.308-1.226 8.98-1.304 11.449-.691 2.407.598 3.653 1.843 4.25 3.395.624 1.626.587 3.73.085 6.072-.497 2.323-1.426 4.766-2.452 6.998l1.817.836c1.06-2.304 2.051-4.895 2.591-7.416.536-2.502.652-5.055-.174-7.207-.855-2.225-2.663-3.881-5.635-4.62C10.245.08 6.214.23.775 1.487l.45 1.948Z'
    />
  </svg>
)
const Memo = memo(CurvedArrow)
export default Memo
